<template>
    <ac-modal :title="'Message Center'" ref="modalRef">
        <slot>
            <div v-if="paginatedMessages.length==0">
                No messages at this time.
            </div>
            <div style="max-height: 390px; overflow: auto;" v-for="message in paginatedMessages">
                <message :message="message"></message>
            </div>
        </slot>
        <slot name="buttons">
            <div v-if="thereAreMoreMessages">
                <a class="cursor-pointer" @click.prevent="showMore">
                    <div class="divider"></div>
                    <h6 class="text-center">SHOW MORE</h6>
                </a>
            </div>
        </slot>
    </ac-modal>
</template>

<script>
    import {common} from "../../global/common.js";
    import {mapGetters} from 'vuex';
    import _ from 'lodash';
    import Message from "./Message.vue";

    export default {
        name: "MessageCenterModal",
        components: {Message},
        data() {
            return {
                entityId: 0,
                entityTypeId: 0
            };
        },
        computed: {
            ...mapGetters(['paginatedMessages', 'messageCount']),
            thereAreMoreMessages() {
                return this.messageCount > 5 && this.paginatedMessages.length < this.messageCount;
            }
        },
        methods: {
            async showModal({entityId, entityTypeId}) {
                //console.log("Opening message center, entityId:", entityId, ' entity type:', entityTypeId);
                this.entityId = entityId;
                this.entityTypeId = entityTypeId;
                await this.$store.dispatch('SET_ENTITY_DATA', {entityId, entityTypeId});
                await this.$store.dispatch('LOAD_MESSAGES');
                this.$refs.modalRef.open();
            },
            showMore() {
                this.$store.dispatch('LOAD_MORE_MESSAGES');
            }
        }

    }
</script>

<style scoped>

</style>